import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import Icontrash from "../images/trash.png";
import Iconupload from "../images/upload.png";
import Iconfiles from "../images/files.png";
import { baseURL } from "../../shared/constants";
import axios from "axios";

const JobsectionsForms = () => {
    const { t } = useTranslation();
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        department: "",
        cv: null as File | null,
    });

    const [errors, setErrors] = useState({
        name: "",
        email: "",
        phone: "",
        department: "",
        cv: "",
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const fileSizeMB = file.size / (1024 * 1024);

            if (fileSizeMB > 5) {
                alert(t("cvSizeExceeded"));
                if (fileInputRef.current) fileInputRef.current.value = "";
                return;
            }

            setFormData({ ...formData, cv: file });
            setErrors({ ...errors, cv: "" });
        }
    };

    const handleRemoveFile = () => {
        setFormData({ ...formData, cv: null });
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const validate = () => {
        const newErrors: typeof errors = {
            name: "",
            email: "",
            phone: "",
            department: "",
            cv: "",
        };
        let isValid = true;

        if (!formData.name.trim()) {
            newErrors.name = t("nameRequired");
            isValid = false;
        }

        if (!formData.email.trim()) {
            newErrors.email = t("emailRequired");
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = t("emailInvalid");
            isValid = false;
        }

        if (!formData.phone.trim()) {
            newErrors.phone = t("phoneRequired");
            isValid = false;
        } else if (formData.phone.length < 9) {
            newErrors.phone = "رقم الجوال يجب أن يكون 9 أرقام";
            isValid = false;
        } else if (!formData.phone.startsWith("5")) {
            newErrors.phone = "رقم الجوال يجب أن يبدأ بـ 5";
            isValid = false;
        }

        if (!formData.department.trim()) {
            newErrors.department = t("departmentRequired");
            isValid = false;
        }

        if (!formData.cv) {
            newErrors.cv = t("cvRequired");
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validate()) return;

        if (loading) return;
        setLoading(true);

        try {
            const formDataToSend = new FormData();
            formDataToSend.append("fullname", formData.name);
            formDataToSend.append("phone", `+966${formData.phone}`);
            formDataToSend.append("email", formData.email);
            formDataToSend.append("jobTitle", formData.department);
            if (formData.cv) formDataToSend.append("cv", formData.cv);

            const response = await axios.post(`${baseURL}/jobs/`, formDataToSend, {
                headers: {
                    "X-Api-Version": "v3",
                    "Content-Type": "multipart/form-data",
                },
            });

            console.log("Response:", response.data);
            window.location.pathname = `/jobs/success`;
        } catch (error: any) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="job-forms">
            <div className="form-top">
                <h3>{t("JobsFormTitle")}</h3>
                <p>{t("JobsFormDesc")}</p>
            </div>

            <form onSubmit={handleSubmit} className="form-content" noValidate>

                {/* الاسم */}
                <div className="form-group">
                    <label>
                        {t("JobsInputName")} <span>*</span>
                    </label>
                    <input
                        type="text"
                        name="name"
                        placeholder={t("JobsInputName")}
                        value={formData.name}
                        maxLength={70}
                        onChange={(e) => {
                            if (e.target.value.length <= 70) handleChange(e);
                        }}
                        className={errors.name ? "is-invalid" : ""}
                    />
                    {errors.name && <span className="errorfiled">{errors.name}</span>}
                </div>

                {/* الإيميل والموبايل */}
                <div className="form-row">
                    <div className="form-group">
                        <label>
                            {t("JobsInputEmail")} <span>*</span>
                        </label>
                        <input
                            type="email"
                            name="email"
                            placeholder="example@gmail.com"
                            value={formData.email}
                            onChange={handleChange}
                            className={errors.email ? "is-invalid" : ""}
                        />
                        {errors.email && <span className="errorfiled">{errors.email}</span>}
                    </div>

                    <div className="form-group">
                        <label>
                            {t("JobsInputPhone")} <span>*</span>
                        </label>
                        <div className={errors.phone ? "is-invalid tel-phone" : "tel-phone"}>
                            <span className="tel-phone-code">966</span>
                            <div className="line"></div>

                            <input
                                type="tel"
                                name="phone"
                                placeholder="5xxxxxxxx"
                                className="tel-phone-input"
                                value={formData.phone}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, "");
                                    if (val.length <= 9) {
                                        setFormData({ ...formData, phone: val });

                                        if (val === "" || val.startsWith("5")) {
                                            setErrors({ ...errors, phone: "" });
                                        } else {
                                            setErrors({
                                                ...errors,
                                                phone: "رقم الجوال يجب أن يبدأ بـ 5",
                                            });
                                        }
                                    }
                                }}
                            />

                        </div>
                        {errors.phone && <span className="errorfiled">{errors.phone}</span>}
                    </div>
                </div>

                {/* إدخال القسم يدويًا */}
                <div className="form-group">
                    <label>
                        {t("JobsInputDepartment")} <span>*</span>
                    </label>
                    <input
                        type="text"
                        name="department"
                        placeholder={t("EnterDepartmentName")}
                        value={formData.department}
                        maxLength={70}
                        onChange={(e) => {
                            if (e.target.value.length <= 100) handleChange(e);
                        }}
                        className={errors.department ? "is-invalid" : ""}
                    />
                    {errors.department && (
                        <span className="errorfiled">{errors.department}</span>
                    )}
                </div>

                <div className="line"></div>

                {/* رفع السيرة الذاتية */}
                <div className="form-group file-group">
                    <label>
                        {t("JobsInputAttachCV")} <span>*</span>
                    </label>
                    <div className="upload-box">
                        <input
                            ref={fileInputRef}
                            type="file"
                            id="cv"
                            onChange={handleFileChange}
                            accept=".pdf"
                        />

                        {!formData.cv ? (
                            <label
                                htmlFor="cv"
                                className={`upload-area ${errors.cv ? "is-invalid" : ""}`}
                            >
                                <img src={Iconupload} alt="Upload" />
                                <div className="upload-text">
                                    <span>{t("JobsInputAttachFile")}</span>
                                    <small>{t("JobsInputSupportedFiles")}</small>
                                </div>
                            </label>
                        ) : (
                            <div className="uploaded-file">
                                <div className="img">
                                    <img src={Iconfiles} alt="File" />
                                </div>
                                <div className="file-info">
                                    <span className="file-name">{t("FileCv")}</span>
                                    <small className="file-size">
                                        {(formData.cv.size / (1024 * 1024)).toFixed(2)} MB
                                    </small>
                                </div>
                                <button
                                    type="button"
                                    onClick={handleRemoveFile}
                                    className="delete-file"
                                >
                                    <img src={Icontrash} alt="Delete" />
                                </button>
                            </div>
                        )}
                    </div>
                    {errors.cv && <span className="errorfiled">{errors.cv}</span>}
                </div>

                {/* زر الإرسال */}
                <button
                    type="submit"
                    className="submit-btn"
                    disabled={
                        loading ||
                        !formData.name.trim() ||
                        !formData.email.trim() ||
                        !formData.phone.trim() ||
                        !formData.department.trim() ||
                        !formData.cv
                    }
                >
                    {loading ? "جارٍ الإرسال..." : t("JobsSubmitButton")}
                </button>
            </form>
        </section>
    );
};

export default JobsectionsForms;
